<div class="page-container container">
  {{SolutionsData}}
</div>